import React from "react";

// Custom Styles
import "./customNavTop.styles.scss";

// Bootstrap components
import Container from "react-bootstrap/Container";

// Assets
import PhoneIconBlue from "../../../assets/img/phone-icon--blue.svg";
import LocationIconBlue from "../../../assets/img/location-icon--blue.svg";
import IgIconBlue from "../../../assets/img/ig-icon--blue.svg";
import FbIconBlue from "../../../assets/img/fb-icon--blue.svg";

function CustomNavTop() {
  return (
    <div
      className="custom-nav__top
  "
    >
      <Container fluid>
        <div className="custom-nav__top__container">
          <h1>Tu lugar #1 en educación profesional</h1>
          <div>
            <a href="tel:+52">
              <img src={PhoneIconBlue} alt="" />
              <span>Soporte a estudiantes</span>
            </a>
            <a
              href="https://maps.app.goo.gl/E1M2KLfXapbHqJ3t8"
              target="_blank"
              rel="noreferrer"
            >
              <img src={LocationIconBlue} alt="" />
              <span>Av. Nazario Ortiz Garza S/N, Aguascalientes, Ags.</span>
            </a>
            <a href="http://" target="_blank" rel="noopener noreferrer">
              <img src={FbIconBlue} alt="" />
            </a>
            <a href="http://" target="_blank" rel="noopener noreferrer">
              <img src={IgIconBlue} alt="" />
            </a>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default CustomNavTop;
